import IcLocation from './IcLocation'

export default IcLocation
